import PlatformIcon from './PlatformIcon'
export default PlatformIcon
